import gsap from "gsap";
import collgeApp from '../../Screenshot 2025-07-06 at 19.54.50.png'
import sqlLint from '../../Screenshot 2025-07-06 at 20.07.15.png'
import aiCodeReviewer from '../../Screenshot 2025-08-11 at 11.28.28.png'
import celsorAI from '../../celsorai.png'
import treaty from '../../treatyai.png'
import fuze from '../../fuzeai.png'
import supabase from '../../supabase-logo-icon.png'
import langchain from '../../langchain-color.png'



export const data = [
    {
        id: 1,
        name: "React.js",
        src: "https://www.svgrepo.com/show/374032/reactjs.svg"
    },
    {
        id: 2,
        name: "ReactNative",
        src: "https://www.svgrepo.com/show/452092/react.svg"
    },
    {
        id: 3,
        name: "TypeScript",
        src: "https://www.svgrepo.com/show/303600/typescript-logo.svg"
    },
    {
        id: 4,
        name: "Next.js",
        src: "https://www.svgrepo.com/show/342062/next-js.svg"
    },
    {
        id: 5,
        name: "JavaScript",
        src: "https://www.svgrepo.com/show/452045/js.svg"
    },
    {
        id: 6,
        name: "HTML",
        src: "https://www.svgrepo.com/show/373669/html.svg"
    },
    {
        id: 7,
        name: "CSS",
        src: "https://www.svgrepo.com/show/349330/css3.svg"
    },
    {
        id: 8,
        name: "TailwindCSS",
        src: "https://www.svgrepo.com/show/354431/tailwindcss-icon.svg"
    },
    {
        id: 9,
        name: "SCSS",
        src: "https://www.svgrepo.com/show/374068/scss.svg"
    },
    {
        id: 10,
        name: "Spring Boot",
        src: "https://www.svgrepo.com/show/354380/spring-icon.svg"
    },
    {
        id: 11,
        name: "Node.js",
        src: "https://www.svgrepo.com/show/354119/nodejs-icon.svg"
    },
    {
        id: 12,
        name: "Java",
        src: "https://www.svgrepo.com/show/353924/java.svg"
    },
    {
        id: 13,
        name: "C++",
        src: "https://www.svgrepo.com/show/353614/c-plusplus.svg"
    },
    {
        id: 14,
        name: "C#",
        src: "https://img.icons8.com/color/512/c-sharp-logo.png"
    },
    
    {
        id: 15,
        name: "Python",
        src: "https://www.svgrepo.com/show/452091/python.svg"
    },
    {
        id: 16,
        name: "MySQL",
        src: "https://www.svgrepo.com/show/354099/mysql.svg"
    },
    {
        id: 17,
        name: "MongoDB",
        src: "https://www.svgrepo.com/show/331488/mongodb.svg"
    },
    {
        id: 18,
        name: "REST API",
        src: "https://www.svgrepo.com/show/375531/api.svg"
    },
    {
        id: 19,
        name: "Git",
        src: "https://www.svgrepo.com/show/452210/git.svg"
    },
    {
        id: 20,
        name: "EXPO",
        src: "https://www.svgrepo.com/show/373591/expo.svg"
    },
    {
        id: 21,
        name: "Clerk",
        src: "https://ph-files.imgix.net/297bc3d4-bd2e-4eaa-8fb6-a289cf61ea91.png?auto=format"
    },
    {
        id: 22,
        name: "Vite",
        src: "https://www.svgrepo.com/show/354521/vitejs.svg"
    },
    {
        id: 23,
        name: "Supabase",
        src: supabase,
    },
    {
        id: 24,
        name: "Firebase",
        src:"https://firebase.google.com/static/images/icons/firebase_studio.png"
    },
    {
        id: 25,
        name: "Bootstrap",
        src: "https://www.svgrepo.com/show/353498/bootstrap.svg"
    },
    {
        id: 26,
        name: "Postman",
        src: "https://www.svgrepo.com/show/354202/postman-icon.svg"
    },
    {
        id: 27,
        name: "LangChain",
        src: langchain,
    },

]


export const projects = [
    {
        name: "Collge App",
        p1: "1. Spring Boot | React Native | Next.js",
        p2: "2. Backend with Spring Boot",
        p3: "3. Frontend with EXPO React Native",
        p4: "4. Built in Collaboration with friends",
        p5: "5. 250+ Users",
        status: "Completed",
        src: collgeApp,
        link: "https://app.collge.io"
    },
    {
        name: "Celsor AI",
        p1: "1. Next.js | TypeScript | CSS | RAG | Firecrawl",
        p2: "2. AI-powered Excel copilot that understands entire workbooks—sheets, formulas, and data relationships",
        p3: "3. Direct implementation: creates tables, writes formulas, applies fixes in-workbook with approval",
        p4: "4. Finance-first: revenue projections, cash-flow schedules, sensitivity analyses; full audit trail in _CelsorMeta",
        status: "Completed",
        src: celsorAI,
        link: "https://celsorai.vercel.app"
    },
    {
        name: "Treaty",
        p1: "1. Next.js | TypeScript | CSS | RAG",
        p2: "2. Contract analysis platform: upload DOCX, get instant AI insights, risk assessment, and negotiation tips",
        p3: "3. Supports 50+ contract types across employment, real estate, healthcare, tech, finance, manufacturing",
        p4: "4. High/Medium/Low risk scoring, industry-specific negotiation points, AI-powered contextual chat",
        status: "Completed",
        src: treaty,
        link: "https://treaty-ai.vercel.app"
    },
    {
        name: "Fuze",
        p1: "1. Next.js | TypeScript | CSS",
        p2: "2. AI M&A deal simulator: analyze deal structures, predict outcomes, generate actionable insights",
        p3: "3. M&A deal simulation with DCF, IRR, NPV, EPS accretion; valuation and scenario management",
        p4: "4. Risk assessment (financial, integration, market); professional PDF reports and AI deal memos",
        status: "Completed",
        src: fuze,
        link: "https://fuze-ai.vercel.app"
    },
    {
        name: "AI Powered Code Reviewer",
        p1: "1. Spring Boot | Python | React JS",
        p2: "2. Designed and implemented an AI-powered code review system integrated with GitLab",
        p3: "3. Built modular backend services in Spring Boot",
        p4: "4. Built interactive front-end dashboards in React.js",
        p5: "5. Automated analysis workflows with Python scripts for intelligent code assessment",
        status: "Completed",
        src: aiCodeReviewer,
    },
    {
        name: "SQL Linting Tool",
        p1: "1. Made using Java",
        p2: "2. Console based Dashboard that authenticates users, assesses SQL health, views alerts, and applies fixes",
        p3: "3. Integrated SQLFluff via Python’s ProcessBuilder to automate linting processes for SQL files",
        p4: "4. Utilized Gson for parsing JSON data from SQLFluff ",
        p5: null,
        status: "Completed",
        src: sqlLint,
        git: "https://github.com/ali2002-collab/SQL-Linting-Tool"
    },
]

export const jobs = [

    {
        id: 1,
        name: "NatWest Group",
        src: "https://companieslogo.com/img/orig/NWG-5dd92b4c.png?t=1720244493",
        list: [
            "1. Role: Software Engineer Intern",
            "2. Collaborated with the test automations team to build and maintain automated testing frameworks",
            "3. Partnered with fellow interns to develop features using Spring Boot, Python and React",
            "4. Leveraged NatWest Group’s AI platform AIDEN to create an AI-driven GitLab code review tool",
            "5. Worked in Agile sprints and coordinated with cross-functional teams",
        ],

    },

    {
        id: 1,
        name: "Huzaima & Ikram",
        src: "https://huzaimaikram.com/media/2024/10/huzaimaikram-logo.png",
        list: [
            "1. Role: Frontend Developer Intern",
            "2. Built a user-friendly admin dashboard using TypeScript, Tailwind CSS, and React.js",
            "3. Added dynamic filters for multi-criteria data sorting",
            "4. Implemented a light/dark mode theme toggle",
            "5. Worked in Agile sprints and coordinated with cross-functional teams",
        ],

    },

]